<!-- When spinner is showing, button type is switched to 'button' to prevent multiple form submissions -->
<button
  #buttonComponent
  class="theme-button"
  [ngClass]="[theme, fontSizeUnit]"
  [class.min-width]="!!useMinWidth"
  [type]="!showSpinner ? type : 'button'"
  [disabled]="disabled"
  [class.has-spinner]="showSpinner"
  [class.full-width]="fullWidth"
  [class.extra-horizontal-padding]="extraHorizontalPadding"
  [attr.id]="internalId ? internalId : null"
  [attr.aria-label]="ariaLabel ? ariaLabel : null"
  [attr.aria-labelledby]="ariaLabelledBy ? ariaLabelledBy : null"
  [attr.aria-controls]="ariaControls ? ariaControls : null"
  [attr.aria-current]="ariaCurrent ? ariaCurrent : null"
  [attr.aria-expanded]="ariaExpanded"
  [attr.role]="role"
  (click)="handleClick($event)"
  [ngbTooltip]="tooltipTemplate || tooltip || buttonTooltip"
  #t="ngbTooltip"
  triggers="manual"
  (mouseleave)="onMouseLeave(t)"
  (mouseenter)="onMouseEnter(t)"
  (focus)="onFocus(t)"
  (blur)="onBlur(t)"
  [tooltipClass]="tooltipClass"
  [disableTooltip]="!(tooltip || tooltipTemplate)"
  [class]="customClass ?? ''"
  [class.extra-top-bottom-padding]="topBottomPaddingSpacingS"
  [class.remove-pointer-events]="removePointerEvents"
  [attr.form]="formId ? formId : null"
  container="body">

  <div
    class="button-content"
    [class.theme-button-with-icon]="!!iconName"
    [attr.aria-hidden]="showSpinner"
  >
    <ng-template [ngTemplateOutlet]="iconPosition == 'left'
                                     ? ZbpButtonIcon : undefined">
    </ng-template>
    <span *ngIf="prefixText" class="prefixText">{{prefixText}}</span>
    {{label}}
    <ng-template [ngTemplateOutlet]="iconPosition == 'right'
                                     ? ZbpButtonIcon : undefined">
    </ng-template>
  </div>
  <div
    [hidden]="!showSpinner"
    class="button-spinner-container"
  >
    <img
      src="/assets/img/Spin-1s-100px.svg"
      alt="Spinner"
      aria-hidden="true"
      class="button-spinner"
    />
  </div>
</button>
<span class="sr-only" aria-live="polite" aria-atomic="true">{{ liveAnnouncement }}</span>
<ng-template #ZbpButtonIcon>
  <zbp-icon *ngIf="!!iconName"
            [iconName]="iconName"
            [primaryColor]="iconPrimaryColor"
            [iconSize]="iconSize">
  </zbp-icon>
</ng-template>
<ng-template #buttonTooltip>
  <span id="iconTooltipContent">{{tooltip}}</span>
</ng-template>
